<script setup>
/**
 * Animates content entering and leaving with a vertical slide motion.
 *
 * @status recommended
 * @group utilities
 * @useWhen Smoothly expanding and collapsing content sections with a slide animation
 * @see https://quasar.dev/vue-components/slide-transition Quasar q-slide-transition API
 */
defineOptions({ name: 'HrSlideTransition' });
</script>

<template>
  <q-slide-transition v-bind="$attrs">
    <!-- @slot Content to animate. -->
    <slot />
  </q-slide-transition>
</template>
